<div class="page-wrapper">
    <!-- <div class="auth-bg"> -->
    <div class="main-box centrado">
        <img src="assets/images/login-back.svg" class="animated-back centrado" alt="">
        <img class="centrado-h logo" src="assets/images/logo-bg-white.png" alt="">

        <form class="theme-form" [formGroup]="loginForm">
            <div class="form-cont" *ngIf="oapp.netsolin_ini && (oapp.netsolin_ini.sas || oapp.netsolin_ini.multiempresa)">
                <input class="form-control" formControlName="nit" type="nit" required="">
                <label class="text centrado-v">Nit</label>
                <div *ngIf="loginForm.controls.nit.touched && loginForm.controls.nit.errors?.required"
                    class="text-danger mt-1">
                    El Nit es obligatorio
                </div>
                <div *ngIf="loginForm.controls.nit.touched && loginForm.controls.nit.errors?.email"
                    class="text-danger mt-1">
                    Nit invalido
                </div>
            </div>
            <div *ngIf="oapp.netsolin_ini && (oapp.netsolin_ini.sas  || oapp.netsolin_ini.multiempresa)">
                <div *ngIf="loginForm.controls.nit.invalid && loginForm.controls.nit.dirty" class="text text-danger mt-1">
                    La empresa {{ loginForm.controls.nit.value }} No se encontro, Contactenos.
                  </div>

                  <div *ngIf="loginForm.controls.nit.valid" class="text text-success mt-1">
                    {{ loginForm.controls.nit.value }}
                  </div>

                  <div *ngIf="loginForm.controls.nit.pending" class="text text-info mt-1 ">
                    Mantenga presionado ... Comprobando existencia de {{ loginForm.controls.nit.value }}
                  </div>
            </div>
            <div class="form-cont">
                <input class="form-control" formControlName="email" type="email" required="">
                <label class="text centrado-v">Email</label>
                <div *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.required"
                    class="text-danger mt-1">
                    El Email es obligatorio
                </div>
                <div *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.email"
                    class="text-danger mt-1">
                    Email invalido
                </div>
            </div>
            <div class="form-cont">
                <input class="form-control" type="password" formControlName="password" required="">
                <label class="text centrado-v">Contraseña</label>
                <div *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.required"
                    class="text-danger mt-1">
                    La contraseña es obligatoria
                </div>
            </div>
            <!-- <div class="check-box">
                <label for="checkbox1">Recordarme</label>
                <input id="checkbox1" type="checkbox">
            </div> -->
            <button class="btn btn-login centrado-h" [class.loader--text]="authService.showLoader"
                [disabled]="!loginForm.valid || authService.showLoader" (click)="login()" type="submit"><span>{{
                    authService.showLoader ? '' : 'Ingresar' }}</span>
            </button>
            <div class="form-row d-flex justify-content-center text-center">
                <div class="col-sm-12 col-md-6 mt-2 clickable">
                    <!-- <a (click)="forgetpsw()">¿Olvido su contraseña?</a> -->
                </div>
                <div class="col-sm-12 col-md-6 mt-2 clickable">
                    <a (click)="goToRegister()">Registrarse</a>
                </div>
            </div>
            <!-- <div class="social mt-3">
                <div class="form-cont btn-showcase d-flex fit centrado-h">
                    <button class="btn social-btn btn-fb d-inline-block" (click)="loginFacebook()">
                        <i class="fa fa-facebook"></i>
                    </button>
                    <button class="btn social-btn btn-twitter d-inline-block" (click)="loginTwitter()">
                        <i class="fa fa-twitter"></i>
                    </button>
                    <button class="btn social-btn btn-google d-inline-block" (click)="loginGoogle()">
                        <i class="fa fa-google"></i>
                    </button>
                </div>
            </div> -->
        </form>
    </div>
    <!-- </div> -->
</div>
